import React from 'react';
import FormElemLabel from '../../../../components/Blackbird/Forms/FormElement/FormElemLabel';

import Input from '../../../../components/Blackbird/Forms/Input/Input';
import TimeZoneSelect from './TimeZoneSelect';
import { FieldErrors, FieldValues, UseFormRegister } from 'react-hook-form';

interface Props {
  errors: FieldErrors<FieldValues>;
  register: UseFormRegister<FieldValues>;
}

export default function TimeAndTimezone({ register, errors }: Props) {
  return (
    <div data-testid="time-and-timezone-form" className="tw:mt-3 tw:flex">
      <div className="tw:mr-3 tw:flex tw:items-end">
        <Input
          showErrorMessageBelow
          containerProps={{
            className: 'tw:mr-6',
          }}
          label={'Run at'}
          inputName="ingestionSchedule.0.time"
          errors={errors}
          inputProps={{
            ...register('ingestionSchedule.0.time', {
              required: 'Select a time',
            }),
            type: 'time',
          }}
        />
        <FormElemLabel>Hrs.</FormElemLabel>
      </div>
      <TimeZoneSelect register={register} errors={errors} />
    </div>
  );
}
